module.exports = __webpack_public_path__ + "img/productDetailTopBg.c719a90f.png";